import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Tags = ({ tags = [] }) => (
  <div className='tags'>
    {_.map(tags, t => <span key={t.id} className='tag'>{t.name}</span>)}
    <span className='icon'><i className='fas fa-plus' /></span>
  </div>
);

Tags.propTypes = {
  tags: PropTypes.instanceOf(Array),
};

Tags.defaultProps = {
  tags: [],
};

export default Tags;



// WEBPACK FOOTER //
// ./src/views/Components/Tags.js